import CTLDownloadFile from "application/components/CTLDownloadFile";
import DefaultCell from "application/components/DefaultCell";
import PAPlayAudio from "application/components/PAPlayAudio";

const operationURLS = {
  list: "customerCDRSecondary/answeredList",
  pdfDownload: "/customerCDRSecondary/generateAndDownloadPdf",
  csvDownload: "/customerCDRSecondary/answered/downloadCSV",
  csvFilter: "customerCDRSecondary/answered/downloadCSV1",
};

const getColumns = () => {
  return [
    {
      Header: "Queue Id",
      accessor: "queue",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      allowReportColumn: true,
      allowReportFilter: true,
      controlType: "multipleSelect",
      options: {
        keyField: "queue",
        keyDescription: "queueName",
        values: [],
        url: "customerCDR/queuesAnswered",
      },
    },
    {
      Header: "Queue Name",
      accessor: "queueName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent ID",
      accessor: "ccAgent",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "multipleSelect",
      allowReportColumn: true,
      allowReportFilter: true,
      options: {
        keyField: "ccAgent",
        keyDescription: "agentFullName",
        values: [],
        url: "customerCDR/agentsAnswered",
      },
    },
    {
      Header: "Agent Name",
      accessor: "agentFullName",
      displayInList: true,
      allowFilter: false,
      dataType: "date",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Date Time",
      accessor: "startTime",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      allowReportColumn: true,
      allowReportFilter: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Caller Id",
      accessor: "agentTalkedTo",
      displayInList: true,
      allowFilter: false,
      dataType: "date",
      dateTime: true,
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    // {
    //   Header: "Duration",
    //   accessor: "duration",
    //   displayInList: true,
    //   allowFilter: false,
    //   dataType: "date",
    //   dateTime: true,
    //   Cell: ({ value }) => <DefaultCell value={value} />,
    // },
    // {
    //   Header: "CLI",
    //   accessor: "callId",
    //   displayInList: true,
    //   allowFilter: false,
    //   dataType: "string",
    //   Cell: ({ value }) => <DefaultCell value={value} />,
    // },

    {
      Header: "Talk Time",
      accessor: "agentTalkTime",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Direction",
      accessor: "callDirection",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Status",
      accessor: "status",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    // {
    //   Header: "UUID",
    //   accessor: "uuid",
    //   displayInList: false,
    //   allowFilter: false,
    //   dataType: "string",
    //   displayInDeleteConfirmation: true,
    //   Cell: ({ value, row }) => <CopyContent value={value} row={row} />,
    // },
    {
      Header: "Play",
      accessor: "",
      displayInList: true,
      downloadReports: false,
      sortDisable: true,
      Cell: ({ row }) => <PAPlayAudio row={row} playanswer="playanswer" />,
    },
    {
      Header: "Download File",
      accessor: "",
      displayInList: true,
      downloadReports: false,
      allowFilter: false,
      dataType: "string",
      allowInForm: false,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <CTLDownloadFile
          row={row}
          value={value}
          downloadanswer={"downloadanswer"}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
